module.exports = __webpack_public_path__ + "img/4.d686e079.png";